import type { ActionTree, ActionContext, GetterTree, Module, MutationTree } from 'vuex';
import { UrlModuleConstant } from '../../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

interface IUrlState {
	url: ltFramework.IUrl;
}

const UrlState: IUrlState = {
	url: {
		initialized: false
	} as ltFramework.IUrl
};

const { action, getter, mutation } = UrlModuleConstant;

const UrlMutations: MutationTree<IUrlState> = {
	[mutation.setUrl](state: IUrlState, payload: ltFramework.IUrl) {
		state.url = payload;
	}
};

export const UrlActions: ActionTree<IUrlState, ltFramework.IRootState> = {
	[action.initialize]({ commit }: ActionContext<IUrlState, ltFramework.IRootState>): Promise<void> {
		return new Promise<void>((resolve) => {
			const url: ltFramework.IUrl = {
				currentUrl: window.location,
				globalPageDrivers: window.lt.globalPageDrivers,
				initialized: true
			};

			commit(mutation.setUrl, url);

			resolve();
		});
	},

	[action.updateUrl](
		{ commit }: ActionContext<IUrlState, ltFramework.IRootState>,
		href: string
	): Promise<void> {
		return new Promise<void>((resolve) => {
			const url: ltFramework.IUrl = {
				currentUrl: window.location,
				globalPageDrivers: window.lt.globalPageDrivers,
				initialized: true
			};

			window.history.replaceState(null, href, href);
			url.currentUrl = window.location;
			commit(mutation.setUrl, url);

			resolve();
		});
	},

	/** used as a notification mechanism between components as they change the url */
	[action.urlUpdated]({ commit }: ActionContext<IUrlState, ltFramework.IRootState>): Promise<void> {
		return new Promise<void>((resolve) => {
			const url: ltFramework.IUrl = {
				currentUrl: window.location,
				globalPageDrivers: window.lt.globalPageDrivers,
				initialized: true
			};

			commit(mutation.setUrl, url);

			resolve();
		});
	}
};

export const UrlGetters: GetterTree<IUrlState, ltFramework.IRootState> = {
	[getter.getGlobalPageDriverUrl]: (state: IUrlState) => (section: string, page: string) => {
		if (!section) {
			throw new Error('Section is not defined');
		}

		if (!page) {
			throw new Error('Page is not defined');
		}

		if (!state.url.globalPageDrivers[section]) {
			throw new Error('Section ' + section + " doesn't exist in global page drivers");
		}

		if (!state.url.globalPageDrivers[section][page]) {
			throw new Error('Page ' + page + " doesn't exist in global page drivers");
		}

		const url: string = state.url.globalPageDrivers[section][page];

		return url;
	}
};

export const UrlModule: Module<IUrlState, ltFramework.IRootState> = {
	namespaced: true,
	state: UrlState,
	getters: UrlGetters,
	actions: UrlActions,
	mutations: UrlMutations
};
